// src/components/store/sections/weekly-banner/WeeklyBannerV82ClaydeckIndigoPulse.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV82ClaydeckIndigoPulse(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={82}
      archKey="clay_deck"
      archLabel="3D Claymorphic Promo Deck"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      {...props}
    />
  );
}
